// Kutu Öneri Asistanı · GA4 ve Shopify uygulama raporu ölçümü (ana sayfa ve kategori, iki görünümde de).
// Aramayı sihirbaz.js'in yaydığı 'sihirbaz:sonuc' olayından, tıklamaları sonuç alanından okur.
//   asistan_arama      olcu (en x boy x yükseklik, yazıldığı sırayla) · sonuc_sayisi (ürünün sığdığı kutu sayısı) · birebir (evet/hayir)
//   asistan_sonuc_tik  kaynak (bu_olcude / sigan / cok_satan) · urun · sira · olcu · birebir
//   asistan_teklif_tik olcu  ("Özel ölçü teklifi alın" bağlantısı ya da düğmesi)
// Yalnız Kutufix GA4 akışına gider (send_to), Google Ads etiketine gitmez.
(function () {
  if (window.kutufixSizeAnalyticsLoaded) return;
  window.kutufixSizeAnalyticsLoaded = true;
  var HEDEF = 'G-2730DVJ9Q3';
  var VISITOR_KEY = 'kutufix_chat_visitor_id';
  var bellekZiyaretci = null;
  var WIZARD_ATTRIBUTES = {
    visitor: '__Kutufix Sihirbaz ziyaretçi kimliği',
    products: '__Kutufix Sihirbaz incelenen ürünler',
    legacyProducts: "__Kutufix Sihirbaz incelenen ürün ID'leri",
    clickedAt: '__Kutufix Sihirbaz ürün tıklama zamanı'
  };

  function kimlikOlustur() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return 'visitor-' + window.crypto.randomUUID();
    return 'visitor-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function ziyaretciKimligi() {
    if (bellekZiyaretci) return bellekZiyaretci;
    try {
      var kayitli = window.localStorage.getItem(VISITOR_KEY);
      bellekZiyaretci = kayitli || kimlikOlustur();
      if (!kayitli) window.localStorage.setItem(VISITOR_KEY, bellekZiyaretci);
    } catch (e) {
      bellekZiyaretci = bellekZiyaretci || kimlikOlustur();
    }
    return bellekZiyaretci;
  }

  function uygulamayaGonder(kok, tur, detay) {
    var endpoint = kok.dataset.analyticsEndpoint;
    if (!endpoint) return;
    void fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        visitorId: ziyaretciKimligi(),
        type: tur,
        productId: detay && detay.productId ? detay.productId : null,
        productHandle: detay && detay.productHandle ? detay.productHandle : null
      })
    }).catch(function () {});
  }

  function istanbulTarihi(tarih) {
    var parcalar = new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul',
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(tarih);
    var degerler = {};
    parcalar.forEach(function (parca) { if (parca.type !== 'literal') degerler[parca.type] = parca.value; });
    return degerler.day + '.' + degerler.month + '.' + degerler.year + ' ' + degerler.hour + ':' + degerler.minute + ':' + degerler.second;
  }

  function urunAciklamasi(urun) {
    var parcalar = [urun.title];
    if (urun.variantTitle && urun.variantTitle !== 'Default Title') parcalar.push(urun.variantTitle);
    if (urun.sku) parcalar.push('SKU: ' + urun.sku);
    return parcalar.filter(Boolean).join(' — ');
  }

  function sepetIliskisiniGuncelle(urun) {
    if (!urun || !urun.id) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var onceki = [];
    try {
      onceki = JSON.parse(window.sessionStorage.getItem('kutufix_wizard_products') || '[]');
      if (!Array.isArray(onceki)) onceki = [];
    } catch (e) {
      onceki = [];
    }
    onceki = onceki.map(function (kayit) {
      return typeof kayit === 'string' ? { id: kayit, title: '', variantTitle: '', sku: '' } : kayit;
    }).filter(function (kayit) { return kayit && kayit.id; });
    var mevcut = onceki.findIndex(function (kayit) { return kayit.id === urun.id; });
    if (mevcut === -1) onceki.push(urun);
    else onceki[mevcut] = urun;
    try { window.sessionStorage.setItem('kutufix_wizard_products', JSON.stringify(onceki)); } catch (e) {}

    var attributes = {};
    attributes[WIZARD_ATTRIBUTES.visitor] = ziyaretciKimligi();
    attributes[WIZARD_ATTRIBUTES.products] = onceki.map(urunAciklamasi).filter(Boolean).join('\n');
    attributes[WIZARD_ATTRIBUTES.legacyProducts] = '';
    attributes[WIZARD_ATTRIBUTES.clickedAt] = istanbulTarihi(new Date());

    void fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  function gonder(ad, veri) {
    if (typeof window.gtag !== 'function') return;
    veri.send_to = HEDEF;
    try { window.gtag('event', ad, veri); } catch (e) {}
  }

  function kur(kapsam) {
    (kapsam || document).querySelectorAll('.sihirbaz-content[data-section-id]').forEach(function (kok) {
      if (kok.dataset.olcumReady === 'true') return;
      kok.dataset.olcumReady = 'true';
      var son = { olcu: '', birebir: 'hayir' };

      kok.addEventListener('sihirbaz:sonuc', function (e) {
        var d = e.detail || {};
        son = { olcu: d.olcu || '', birebir: d.birebir || 'hayir' };
        if (d.geri_yuklendi) return;
        gonder('asistan_arama', { olcu: son.olcu, sonuc_sayisi: d.sigan_sayisi || 0, birebir: son.birebir });
        uygulamayaGonder(kok, 'WIZARD_SEARCH');
      });

      kok.addEventListener('click', function (e) {
        var a = e.target.closest('a');
        if (!a || !kok.contains(a)) return;

        if (a.classList.contains('cx-kart')) {
          var ad = a.querySelector('.cx-ad');
          gonder('asistan_sonuc_tik', {
            kaynak: a.dataset.bolum === 'kutu' ? 'bu_olcude' : 'sigan',
            urun: ad ? ad.textContent.trim() : a.getAttribute('href'),
            sira: parseInt(a.dataset.sira || '0', 10),
            olcu: son.olcu,
            birebir: son.birebir
          });
          var urunId = String(a.dataset.productId || '');
          uygulamayaGonder(kok, 'WIZARD_PRODUCT_CLICK', {
            productId: urunId,
            productHandle: a.dataset.productHandle || null
          });
          sepetIliskisiniGuncelle({
            id: urunId,
            title: a.dataset.productTitle || (ad ? ad.textContent.trim() : ''),
            variantTitle: a.dataset.variantTitle || '',
            sku: a.dataset.productSku || ''
          });
          return;
        }

        if (a.closest('.cx-teklif') || a.classList.contains('cx-btn')) {
          gonder('asistan_teklif_tik', { olcu: son.olcu });
          return;
        }

        if (a.classList.contains('sx-cip')) {           // Vitrin: çok satan düğmesi
          var cipler = Array.prototype.slice.call(kok.querySelectorAll('.sx-cip'));
          gonder('asistan_sonuc_tik', {
            kaynak: 'cok_satan',
            urun: a.textContent.trim() || a.getAttribute('href'),
            sira: cipler.indexOf(a) + 1
          });
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', function (e) { kur(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); }); else kur();
})();
